export default {
  "meeting": {
    applyrecurring: 'A módosítások az új ismétlődő ütemezésre lesznek alkalmazva. A korábbi értekezletek változatlanok maradnak.',
    recurrenceDescribeTwo: 'Minden {loopPulse}. héten, {week} napon ismétlődik {start} és {end} között',
    wanttodeletethemeetingfollowTwo: 'Törli a kijelölt értekezletet és az összes azt követő ismétlődő értekezletet?',
    loopCycleSelectTips: 'Kérjük, válassza ki az ismétlés napját a héten.',

    export: 'Exportálás',
    exportMeetingFileFuncTipsTitle: 'Exportálás megerősítése',
    exportMeetingFileFuncTipsContentOne: 'Nincs szűrő alkalmazva. A rendszer alapértelmezés szerint az aktuális év értekezletadatait exportálja.',
    exportMeetingFileFuncTipsContentTwo: 'Más időszak értekezleteinek exportálásához kérjük, alkalmazza a kívánt szűrőket exportálás előtt.',

    myMeetingSearch: 'Saját értekezleteim',
    meetingTimeSearch: 'Értekezlet ideje',
    meetingRoomsSearch: 'Tárgyaló',

    Recurring: 'Ismétlődés:',
    wanttodeletethemeetingfollow: 'Biztosan törölni szeretné ezt az értekezletet és az összes következő értekezletet?',
    endTimeCannotBeforeBeginTime: 'A befejezési dátum nem lehet korábbi a kezdési dátumnál',
    Thismeeting: 'Ez az értekezlet',
    Recurringmeeting: 'Ismétlődő értekezlet',
    Checkin: 'Bejelentkezés:',
    checkinTip: 'Az engedélyezés után a résztvevők a tárgyalóterem-ütemező QR-kódjának beolvasásával jelentkezhetnek be.',
    Recurrence_Setrecurrence: 'Ismétlődés beállítása',
    Recurrence_Start: 'Kezdés',
    Recurrence_RepeatEvery: 'Ismétlés minden',
    Recurrence_Week: 'Hét',
    Recurrence_end: 'Befejezés',
    recurrenceDescribe: 'Minden {week} alkalommal ismétlődik {start} és {end} között',
    Recurrence_DoesnotRepeat: 'Nem ismétlődik',
    Recurrence_Weekly: 'Hetente',

    AddressBookUser: 'Felhasználó',
    AddressBookPhonebook: 'Címjegyzék',

    RoomByPeopleNum1: '2 fő vagy kevesebb',
    RoomByPeopleNum2: '3-6 fő',
    RoomByPeopleNum3: '7-10 fő',
    RoomByPeopleNum4: '11-15 fő',
    RoomByPeopleNum5: '16-20 fő',
    RoomByPeopleNum6: '21-30 fő',
    RoomByPeopleNum7: 'Több mint 30 fő',

    whoAreBound: 'A rendszerfiókhoz kapcsolt felhasználók látni fogják az értekezletet a rendszer naptárában. Az e-mail címet megadó felhasználók értesítést kapnak e-mailben. Az értesítésekhez töltse ki adatait a [Profilom] menüpontban.',

    AttendessMeeting: 'Résztvevők:',
    SelectAttendessMeetingTip: 'Résztvevők kiválasztása',

    MeetingFilter: 'Értekezlet szűrő',
    HostedbyMe: 'Általam szervezett',
    Invitedby: 'Meghívottként',
    Otherby: 'Egyéb',

    "AddressIsDuplicated": "A kapcsolattartó e-mail címe duplikált",
    "meetingExpired": "Lejárt",
    titlePhoneFormat: 'A telefonszám csak számokat, () + és - jeleket tartalmazhat.',
    "selectField": "Kérjük, válasszon fájlt",
    "Limit255": "A fájl neve nem lehet hosszabb 255 karakternél",
    "nameLimit25": "A név nem lehet hosszabb 25 karakternél",
    "emailLimit50": "Az email nem lehet hosszabb 50 karakternél",
    "emailFormatError": "Érvényes email címet adjon meg",
    "phoneLimit11": "A telefonszám legfeljebb 11 számjegyet tartalmazhat",
    "ParticipantsEmail": "Résztvevő email címe:",
    "listIsEmpty": "A lista üres",
    "Startimporting": "Feltöltés indítása",
    "Selectfile": "Fájl kiválasztása",
    "Importfile": "Fájl importálása",
    "ImportfileTip": "*Csak Outlook-formátumú CSV (.csv) vagy vCard (.vcf) fájlok importálhatók.",
    "addParticipants": "Résztvevő hozzáadása",
    "multiselectdeselect": "Címke törlésének jelzése",
    "multiselectselected": "Kiválasztott jelzés",
    "enterOrSelectALabel": "Válassza ki a résztvevő email címét",
    "deleTitleContact": "Biztosan törölni szeretné ezt a kapcsolatot?",
    "delTitleContactContent": "Kapcsolat törlése?",
    "deleteContactTitle": "Kérjük, válassza ki a törölni kívánt kapcsolatot",
    "editcontact": "Kapcsolat szerkesztése",
    "Name": "Név",
    "email": "Email",
    "telephoneNumber": "Telefon",
    "Addcontact": "Kapcsolat hozzáadása",
    "Importcontactfile": "Kapcsolatok importálása",
    "AddressBook": "Címtár",
    "Participants": "Résztvevők:",

    bindTipContent:"Ez a szervezet már kötött egy harmadik fél naptárát. Kérjük, ütemezze a találkozókat az Outlook/Teams segítségével.",
    Productupdatenews: 'Új verziófrissítés jelent meg.',
    bookingPerson: 'Lefoglalva',
    "DeleteMeeting": "Találkozó törlése",
    "wanttodeletethemeeting": "Biztosan törölni szeretné a találkozót?",
    "hasbeendeleted": "A találkozó törölve lett",
    "theMeetingWasAborted": "Találkozó idő előtti befejezése",
    "theMeetingWasAbortedContent": "Biztosan idő előtt befejezi a találkozót?",
    "determineTheAbortTask": "Találkozó idő előtti befejezése",
    "theMeetingEndedEarly": "A találkozó idő előtt befejeződött.",
    "with": "with",
    "Other": "Más",
    "tasks": "feladatok",
    "conflict": "ütköznek",
    "meetConflicts": "A következő értekezlet időpontja ütközik:",
    "itIsNotAllowedToSelectThePastTime": "A múltbeli időpontok nem választhatók",
    "selected": "Kiválasztva",
    "noOverFive": "Ne válasszon több mint 5 értekezlet szobát",
    "approvalOpinions": "Jóváhagyási vélemények",
    "beyondTheTimeLimitItCannotBeSelected": "A határidőn túl nem választható",
    "startMonth": "Kezdő hónap",
    "to": "-tól",
    "stopMonth": "Hónap vége",
    "didnTStart": "Nincs kezdés",
    "ONGOING": "Folyamatban",
    "ENDED": "Befejeződött",
    "hasBeen": "Megtörtént",
    "booking": "Foglalás",
    "Approval": "Jóváhagyás",
    "MeetingRoom": "Tárgyalóterem",
    "AllRoom": "Minden terem",
    "Available": "Elérhető",
    "Initiate": "Találkozó indítása",
    "MeetingApproval": "Találkozó jóváhagyása",
    "PreviousMonth": "Előző hónap",
    "Today": "Ma",
    "NextMonth": "Következő hónap",
    "YearMonth": "Év/Hónap",
    "TimeDisplay": "Idő megjelenítése",
    "MeetingTitleAbbreviation": "Találkozó cím rövidítése",
    "InitiateMeeting": "Találkozó indítása",
    "PendingMeetings": "Következő találkozók",
    "AllMeetings": "Minden találkozó",
    "noMeetings": "Jelenleg nincs találkozó, amire menni kellene",
    "NotStarted": "Nincs kezdés",
    "Organizer": "Szervező",
    "MeetingDateTime": "Dátum és idő",
    "MeetingLocation": "Helyszín",
    "MeetingSubject": "Találkozó téma",
    "Invited": "Meghívottak",
    "PeopleAccepted": "Előre elfogadott személyek",
    "EditMeeting": "Találkozó szerkesztése",
    "CancelMeeting": "Találkozó lemondása",
    "InitiateEditMeeting": "Találkozó indítása/szerkesztése",
    "Subject": "Téma",
    "Presenter": "Előadó:",
    "DateTime": "Dátum és idő",
    "TimeAndZone": "Időzóna",
    "Attendees": "Résztvevők",
    "Addrequiredattendees": "Kötelező résztvevők hozzáadása",
    "SelectRooms": "Termek kiválasztása",
    "Reminder": "Emlékeztető",
    "Remindbeforestart": "Emlékeztető a kezdés előtt",
    "Confirm": "Megerősítés",
    "topic": "Téma:",
    "topicplace": "Új találkozó cím:",
    "speaker": "Előadó:",
    "speakerplace": "Kérem, adja meg az előadó információit",
    "DateAndTime": "Dátum és idő:",
    "TimeZone": "Időzóna",
    "EndDate": "Befejezési dátum",
    "Rooms": "Termek:",
    "Notes": "Jegyzetek:",
    "MeetingRoomApproval": "Tárgyalóterem jóváhagyása",
    "PendingApproval": "Várakozó jóváhagyás",
    "Approved": "Jóváhagyva",
    "nopendingapprovals": "Nincsenek várakozó jóváhagyások",
    "Applicant": "Jelentkező",
    "UsageTime": "Használati idő",
    "ApprovalResult": "Jóváhagyási eredmény",
    "ApprovalComments": "Jóváhagyási megjegyzések",
    "Approve": "Jóváhagyás",
    "Reject": "Elutasítás",
    "Search": "Keresés",
    "Filter": "Szűrő",
    "scanTheQRCodeToSignIn": "Olvassa be a QR kódot a bejelentkezéshez"
  },
  "NPS": {
    "Relay": "Átjátszó",
    "RelaySettings": "Átjátszó beállítások",
    "DevicePower": "Eszköz áramellátás vezérlés",
    "DeviceElevation": "Emelés vezérlés",
    "LinageWithNPSPower": "Kapcsolódás az NPS áramellátáshoz",
    "PresentationSwitch": "Prezentációs kapcsoló",
    "Duplicate": "Másolat",
    "LinkagewithNPSPowe": "Kapcsolódás az NPS áramellátáshoz",
    "npsTooltip": "USB eszközök csak a PC gazdagép által kapcsolhatóak be, amely HDMI OUT 1-re van állítva.",
    "nmpTooltip": "Kattintson a „Másolat” gombra a képernyőtartalom tükrözéséhez más kijelzőkön, szinkronizálva a kijelzőt több képernyőn."
  },
  "textTemplate": {
    "template2513": "Tűzriadó közvetítés",
    "template2514": "Kérem, az evakuálás során a tűzriadó terv szerint az alapvető kijáraton és tűzoltó kijáraton keresztül menjenek biztonságos helyre.",
    "moreTemplate": "Sablon korlát elérve",
    "add": "Hozzáadás",
    "SetTemplate": "Sablon beállítása",
    "Emergency": "Sürgősségi",
    "General": "Általános",
    "BroadcastDevices": "Közvetítő eszköz:",
    "selectBroadcastDevices": "Kérem, válasszon közvetítő eszközt",
    "All": "Minden",
    "AddTemplate": "Hozzáadni sablont",
    "EditTemplate": "Sablon szerkesztése",
    "deleteTemplage": "Biztos benne, hogy törölni szeretné a kijelölt sablont?",
    "title": "Sablon törlése",
    "selectTemplage": "Kérem, válasszon sablont!",
    "DeleteCancelled": "Törlés törölve!",
    "DeletedSuccessfully": "Sikeresen törölve!",
    "noData": "Nincs használható sablon, kattintson a jobb felső sarokban a sablon hozzáadásához.",
    "TemplateTitle": "Sablon cím:",
    "BroadcastType": "Közvetítés típusa:",
    "BroadcastTypeDialog": "Közvetítés típusa:",
    "selectBroadcastType": "Kérem, válasszon közvetítési típust",
    "BroadcastDuration": "Közvetítés időtartama:",
    "BroadcastDevice": "Közvetítő eszköz:",
    "BroadcastContent": "Közvetítés tartalma:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Hiba!",
    "mediaTimeStateNotifyErrorContent": "A streaming szolgáltatása lejárt, kérjük, vegye fel a kapcsolatot ügynökével a meghosszabbításhoz.",
    "mediaTimeStateNotifyWarnTitle": "Figyelem!",
    "mediaTimeStateNotifyWarnContent": "Jelenleg próbaverzióban van, amely csak legfeljebb 3 terminál eszközre képes közvetíteni és élő adást sugározni.",
    "mediaTimeStateNotifySuccessTitle": "Sikeres meghosszabbítás",
    "mediaTimeStateNotifySuccessContent": "A streaming szolgáltatása készen áll a normál használatra. Köszönjük.",
    "company": "Cég neve:",
    "tableAddress": "Cím:",
    "createTime": "Létrehozás ideje:",
    "email": "Email:",
    "phone": "Telefon:",
    "Trial": "Próba",
    "TrialWorkstation": "Jelenleg próbaverzióban van, amely csak legfeljebb 3 terminál eszközhöz képes közvetíteni és élő adást sugározni.",
    "Normal": "Normál",
    "NormalWorkstation": "A streaming szolgáltatása érvényességi időtartama:",
    "to": "tól",
    "Advent": "Advent",
    "AdventWorkstationOne": "A streaming szolgáltatása lejár:",
    "AdventWorkstationTwo": ", kérjük, vegye fel a kapcsolatot ügynökével a meghosszabbításhoz, hogy normálisan használhassa.",
    "Expired": "Lejárt",
    "ExpiredWorkstation": "A streaming szolgáltatása lejárt, kérjük, vegye fel a kapcsolatot ügynökével a meghosszabbításhoz.",
    "": " "
  },
  "route": {
    "dashboard": "Irányítópult",
    "i18n": "I18n",
    "Devices": "Eszközök",
    "Broadcast": "Közvetítés",
    "Schedule": "Ütemezés",
    "Resources": "Erőforrások",
    "Live": "Élő",
    "meetings": "Találkozó"
  },
  "navbar": {
    "updates":"Legújabb frissítések",
    "logOut": "Kijelentkezés",
    "screenfull": "képernyő teljes",
    "oprofile": "Saját profil",
    "settings": "Beállítások",
    "language": "Nyelv",
    "BackTianwa": "Vissza a Tianwa-ra",
    "newUserGuide": "Új felhasználói útmutató"
  },
  "feedback": {
    "Feedback": "Visszajelzés",
    "email": "Kérjük, hagyja meg az e-mail címét a visszajelzéshez.",
    "content": "Üdvözöljük, és hagyjon üzeneteket a termékeink fejlesztéséhez. Köszönjük a visszajelzését.",
    "submit": "Beküldés",
    "emailNoEmpty": "Az e-mail cím nem lehet üres",
    "emailTrueRule": "Kérjük, adja meg a helyes e-mail formátumot",
    "contentNoEmpty": "A tartalom nem lehet üres",
    "feedbackSuccess": "Visszajelzés sikeres",
    "feedbackFailed": "Visszajelzés sikertelen",
    "emailNoChinese": "A postaláda nem tartalmazhat kínai karaktereket",
    "emailLength": "5 és 50 karakter között legyen",
    "emailSpecialString": "A postaláda nem tartalmazhat speciális karaktereket"
  },
  "login": {
    checkPasswordTitleTwo: 'Kérjük, állítson be legalább 6 karakter hosszú jelszót, amely betűket és számokat tartalmaz. Speciális karakterek használata engedélyezett (korlátozás nélkül).',
    captcha: 'Ellenőrző kód',
    checkPasswordTitle: 'A jelszónak legalább 6 karakterből kell állnia, és nem lehet csak számokból',
    "title": "ÜDVÖZÖLJÜK",
    "logIn": "Bejelentkezés",
    "consoleLogin": "Konzol bejelentkezés",
    "username": "Felhasználónév",
    "password": "Jelszó",
    "any": "bármely",
    "thirdparty": "Vagy csatlakozzon",
    "thirdpartyTips": "Nem szimulálható helyben, ezért kérjük, kombinálja saját üzleti szimulációját! ! !",
    "placeholder": "[\n  \"Felhasználónév\",\n  \"Jelszó\",\n  \"Vercode\"\n]",
    "userNameTitle": "Hibás felhasználónév!",
    "forget": "Elfelejtette?",
    "loginTitle0": "Sikeres bejelentkezés!",
    "loginTitle1000": "Hibás felhasználónév vagy jelszó!",
    "loginTitle1001": "A felhasználónevet és a jelszót ki kell tölteni!",
    "loginTitle1002": "A megerősítő kódot ki kell tölteni!",
    "loginTitle1003": "A felhasználó státusza érvénytelen, bejelentkezés sikertelen!",
    "loginTitle1004": "Megerősítő kód hiba!",
    "loginTitle1005": "Nincs bejelentkezve, kérjük, először jelentkezzen be!",
    "loginTitle1006": "A két jelszó különbözik!",
    "loginTitleUserName": "A felhasználónevet ki kell tölteni!",
    "loginTitlePwd": "A jelszót ki kell tölteni!",
    "loginTitleVercode": "A megerősítő kódot ki kell tölteni!",
    "titleLoginNameFormat": "A fióknak karakterekből, vagy karakterekből és számokból kell állnia.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Eszközök",
    "btnRoadcast": "Közvetítés",
    "btnResources": "Erőforrások",
    "btnLive": "Élő",
    "meetings": "Találkozó",
    "todaySchedule": "Ma ütemezés",
    "allSkedules": "Minden ütemezés",
    "details": "Részletek",
    "btnStart": "Indítás",
    "titleContent": "Üdvözöljük! A Q-NEX Konzol az Ön szolgálatában. Kezdjük el!",
    "btnExit": "Kilépés"
  },
  "devices": {
    ptzCamera:'PTZ kamera',
    "start": "Kezdés",
    "stop": "Leállítás",
    "nmpPowerOff_mandatory": "Közvetítés alatt (nem kötelező)",
    "nmpPowerOff_nomandatory": "Közvetítés alatt (nem kötelező). Folytatja a végrehajtást?",
    "nmpsPowerOff_mandatory": "Néhány NMP közvetítés alatt (kötelező).",
    "nmpsPowerOff_nomandatory": "Néhány NMP közvetítés alatt (nem kötelező). Folytatja a végrehajtást?",
    "reset": "Visszaállítás",
    "displayedInTheControlArea": "Megjelenítve a vezérlőközpontban",
    "dragOrder": "Húzási sorrend",
    "areaSettingTwoNotice": "*RS232, AC vezérlés és távirányító a vezérlőközpontban az NMP kötődési státuszától függően jelenik meg a műszerfalon.",
    "areaSettingThreeNotice": "*CBX vezérlés a vezérlőközpontban az NMP kötődési státuszától függően jelenik meg a műszerfalon.",
    "controlSet": "Vezérlőközpont beállítás",
    "vcbNoLine": "Nincs online CBX eszköz",
    "vcbNoBound": "Nincs kötött CBX eszköz",
    "tscNoBound": "Az RS232 a TSC-n nincs kötve adatokhoz. Kérjük, értesítse az adminisztrátort, hogy kösse be a műszerfalon.",
    "light": "Áramellátás vezérlés",
    "vcbpower": "Áram",
    "rs232Control": "Sorozatvezérlés",

  "CBX": {
    "powerSupplyON": "Bekapcsolás",
    "powerSupplyOFF": "Kikapcsolás",
    "lockScreenON": "Zár be",
    "lockScreenOFF": "Zár ki",
    "childLockON": "Gyerekzár be",
    "childLockOFF": "Gyerekzár ki",
    "energySavingON": "Energiatakarékos mód be",
    "energySavingOFF": "Energiatakarékos mód ki",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Hangsugárzó",
    "brightAdjustment": "Fényerő",
    "other": "Egyéb funkciók..."
  },

    "InterfaceOne": "Első interfész",
    "InterfaceTwo": "Második interfész",
    "abcStyleP": "Elnézést! A TSC és (NMP, MBX, NPS, NDP100, NDP500) nem választhatók egyszerre",
    "masterControl": "fő",
    "powerSupply": "Áramellátás",
    "RecordingControl": "Felvétel vezérlés",
    "RecordingControlSystem": "Előadás rögzítési rendszer",
    "LiquidCrystal": "Interaktív LCD kijelző",
    "projector": "Projektor",
    "othertype": "Egyéb",
    "lockScreen": "Zár",
    "childLock": "Gyerekzár",
    "energySaving": "Energiatakarékos",
    "signalSourceSwitching": "Bemeneti forrás",
    "volumeAdjustment": "Hangszóró",
    "brightAdjustment": "Fényerő",
    "other": "Egyéb funkciók",
    "otherFunction": "Funkció",
    "send": "Küldés",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Légkondicionáló",
    "titleDevices": "Csoportok szűrése:",
    "content": "Keresés",
    "selectALL": "Mind kiválasztása",
    "SelectRecentPage": "Aktuális oldal kiválasztása",
    "controlPanel": "Vezérlőközpont",
    "displayInputSwitch": "Bemenet váltás kijelző",
    "chooseINPUTSources": "Válassza ki a BEMENET forrásokat",
    "speakerVolume": "Hangszint",
    "bass": "Mélyhang",
    "treble": "Magas hang",
    "MICVolume": "Mikrofon hangerő",
    "AirConditioning": "Légkondicionáló",
    "model": "Típus",
    "setTemp": "Beállított hőmérséklet",
    "fanSpeed": "Ventilátor sebesség",
    "bold": "Lengés",
    "projectionScreen": "Projektor vászon",
    "electronicLock": "Elektromos zár",
    "electronicLock1": "Elektromos zár",
    "selectDevices": "Kérem válasszon eszközt vagy eszközcsoportot",
    "isCompelType": "Eszközvezérlés nem elérhető kötelező közvetítés miatt, próbálja újra később.",
    "mainPower": "Fő áramellátás",
    "extraPower": "Kiegészítő áramellátás",
    "power": "Áramellátás",
    "hdmiBroadcast": "Közvetítés",
    "equipmentState1": "Áram BE",
    "equipmentState2": "Áram KI",
    "equipmentState3": "Offline",
    "main": "Fő",
    "external": "Külső",
    "ProjectionScreen": "Projektor vászon",
    "UP": "FEL",
    "DOWN": "LE",
    "LOCK": "ZÁR",
    "UNLOCK": "FELOLD",
    "PleaseDevice": "Kérem válasszon eszközt/eszközöket a bal oldalon",
    "RemoteControl": "Távirányító",
    "Action": "Művelet",
    "Devicefilter": "Eszközkiválasztás",
    "DeviceStatus": "Státusz",
    "DeviceType": "Típus",
    "currentAudioSource": "Jelenlegi audio forrás",
    "audioSwitching": "Hang kimenet váltás"
  },
  "broadcast": {
    "isBoarding": "(Közvetítés alatt)",
    "last3Days": "UTOLSÓ 3 NAP",
    "last7Days": "UTOLSÓ 7 NAP",
    "last30Days": "UTOLSÓ 30 NAP",
    "historyRecord": "Történelem",
    "SelectDestination": "1. Válassza ki a célt",
    "BroadcastingConsole": "2. Közvetítő Konzol",
    "Notification": "Értesítés",
    "btnStop": "Leállítás",
    "btnStart": "Indítás",
    "Letters60": "(kevesebb, mint 60 karakter)",
    "Letters300": "(kevesebb, mint 300 karakter)",
    "LastingTime": "Tartózkodási idő:",
    "Title": "Cím:",
    "Content": "Tartalom:",
    "Cannotquit": "Kötelező közvetítés",
    "ChooseMedia": "Válasszon egy média fájlt",
    "Broadcasting": "Közvetítés",
    "dialogTitle": "Videó- és audioforrások",
    "SortBy": "Rendezés",
    "btnBake": "Vissza az előzőhöz",
    "cancel": "Mégsem",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "coxAll": "Minden",
    "PublicCloud": "Nyilvános tároló",
    "IndividualCloud": "Személyes tároló",
    "selFile": "Kérem válasszon egy fájlt vagy egy csoportot.",
    "StopBroadcast": "Közvetítés leállítása",
    "StartBroadcasting": "Közvetítés indítása",
    "StopBroadcasting": "Közvetítés leállítása",
    "ForceQuit": "Kényszerített bezárás",
    "PleaseMediaFile": "Kérem válasszon egy média fájlt",
    "PleaseDevice": "Kérem válasszon egy eszközt",
    "broadcast_0": "Közvetítés indítása",
    "broadcast_2500": "Túllépte a csatlakoztatható eszközök maximális számát a Média Szerveren",
    "broadcast_2501": "Közvetítő fájl hiba",
    "broadcast_2502": "A közvetítés véget ért",
    "broadcast_2503": "Nem sikerült lekérni a Média Szerver információkat",
    "broadcast_2510": "Figyelem! Jelenleg próbaállapotban van, legfeljebb 3 terminál eszköz fogadhat közvetítési parancsokat. Kérem ellenőrizze a kiválasztott eszközök számát.",
    "broadcast_2018": "A streaming szolgáltatás leállt",
    "broadcast_2019": "A streaming szolgáltatás lejárt",
    "broadcast_2512": "Túllépte a sablonok maximális számát.",
    "broadcast_2513": "Tűzvédelmi közvetítés",
    "broadcast_2514": "Kérem, az evakuálás során a vész- és tűzoltó kijáraton keresztül haladjon biztonságos helyre a tűzoltási terv szerint.",
    "broadcast_2006": "Az eszközt nem található",
    "broadcast_2": "A lemezszolgáltatás rendellenes",
    "broadcast_2515": "Válasszon egy eszközt, amely nem rendelkezik közvetítési képességekkel",
    "broadcast_2516": "Válasszon olyan fájlokat, amelyek meghaladják az NMP által támogatott maximális felbontást",
    "broadcast_2517": "Válasszon olyan fájlokat, amelyek meghaladják az NDP500 által támogatott maximális felbontást",
    "broadcast_Title": "Közvetítési figyelmeztetés.",
    "broadcast_TitleNDP500": "NDP500 közvetítési figyelmeztetés",
    "broadcast_content": "Az eszköz legfeljebb 4K@30FPS-t támogat, optimális felbontása 1080P@30FPS.",
    "broadcast_contentNDP500": "Az NDP500/600 legfeljebb 1080P@30FPS-t támogat, optimális felbontása 720P@30FPS.",
    "broadcast_noSupported": "A következő kiválasztott videók nem támogatottak a közvetítéshez:",
    "broadcast_noSupportedNDP500": "A következő kiválasztott videók nem támogatottak az NDP500/600 közvetítéséhez:"
  },
  "resources": {
    "uploadNameLengthError": "A fájlnév nem haladhatja meg a 100 szót!",
    "onUploadFile": "Nincsenek feltöltendő fájlok",
    "open": "Megnyitás",
    "fold": "Összehúzás",
    "close": "Bezárás",
    "PublicCloud": "Nyilvános tároló",
    "IndividualCloud": "Személyes tároló",
    "TransfersHistory": "Átvitel előzményei",
    "btnDownload": "Letöltés",
    "btnDelete": "Törlés",
    "btnUploadFile": "Fájl feltöltése",
    "btnNewFolder": "Új mappa",
    "btnBake": "Vissza az előzőhöz",
    "coxAll": "Minden",
    "uploadError": "A feltöltendő fájl mérete nem haladhatja meg az 1 GB-ot!",
    "MD5": "MD5 ellenőrzés",
    "merge": "Egyesítés",
    "transcoding": "Átkódolás",
    "uploadFailed": "Feltöltés sikertelen",
    "fileError": "Fájl olvasási hiba, kérjük ellenőrizze a fájlt.",
    "tableName": "Név",
    "tableSize": "Méret",
    "tableType": "Típus",
    "tableTimeAdded": "Hozzáadás időpontja",
    "tableAction": "Művelet",
    "btnRename": "Átnevezés",
    "btnMoveTo": "Mozgatás ide...",
    "ClearAll": "Mindent töröl",
    "cancel": "Mégsem",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "addSuccess": "Sikeres hozzáadás!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Sikeres szerkesztés!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Sikeres törlés!",
    "delError": "Törlés sikertelen!",
    "diskError3000": "Túllépte a teljes tárolókapacitást, művelet sikertelen!",
    "diskError3001": "Túllépte a nyilvános tárolókapacitást, művelet sikertelen!",
    "diskError3002": "Túllépte az egyéni tárolókapacitást, művelet sikertelen!",
    "diskError3003": "Nem található adat, kérjük ellenőrizze, hogy a média szerver hozzá van-e rendelve!",
    "diskError3004": "A mappa neve már létezik!",
    "diskError3005": "A mappa lekérése sikertelen!",
    "diskError3006": "A következő szinten nem hozható létre több mint 99 mappa!",
    "diskError3007": "A fájlnevek azonosak és a módosítás sikertelen!",
    "diskError3008": "A mappanevek azonosak és a módosítás sikertelen!",
    "diskError3009": "A fájl meghaladja a fennmaradó helyet és a feltöltés sikertelen!",
    "diskError3010": "A fájl feltöltése sikertelen!",
    "diskError3011": "A fájl ellenőrzése sikertelen, kérjük töltsd fel újra!",
    "diskError3012": "A privát felhő cím lekérése sikertelen, művelet nem sikerült!",
    "diskError3013": "A több fájl egyesítése nem haladhatja meg a 100 MB-ot, a nagy fájlokat külön töltsd le!",
    "diskError3014": "A tömörítés sikertelen, kérjük válassza ki újra a fájlt a letöltéshez!",
    "diskError3015": "Ehhez a művelethez jogosultság szükséges",
    "downloadError": "Letöltés sikertelen!",
    "mobileError": "Mozgatás sikertelen!",
    "root": "Minden fájl",
    "Name": "Név",
    "Size": "Méret",
    "Type": "Típus",
    "uploadFile": "Fájl feltöltése",
    "newFolder": "Új mappa",
    "tableTime": "Idő",
    "permission": "Nincs elegendő jogosultság!",
    "notifyTitle": "Értesítés",
    "notifyContent": "A felhasználónak nincs elegendő jogosultsága a hozzáféréshez!",
    "sortFileName": "Fájl neve",
    "sortTime": "Idő",
    "sortSize": "Méret",
    "sortType": "Típus",
    "moveTo": "Mozgatás ide",
    "test": "Új",
    "delTitle": "Törlés?",
    "delTitleContent": "A kijelölt tartalom törlődik az adatbázisból. A művelet nem vonható vissza. Biztos, hogy folytatni szeretnéd?",
    "delCancelButton": "Mégsem",
    "delConfirmButton": "Megerősítés"
  },
  "userMge": {
    "userName": "Felhasználónév:",
    "jobNumber": "Munkavállalói azonosító:",
    "email": "E-mail:",
    "phone": "Telefon:",
    "group": "Csoport:",
    "oldPassword": "Régi jelszó:",
    "newPassword": "Új jelszó:",
    "confirmNewPassword": "Új jelszó megerősítése:",
    "btnSave": "Változtatások mentése",
    "titleChangePassword": "Jelszó módosítása",
    "titleMyProfile": "Profilom",
    "name": "Becenév:",
    "error1400": "A fiók (egyedi) már létezik, a művelet nem sikerült!",
    "error1401": "A fiók (rendszer által generált) már létezik, a művelet nem sikerült!",
    "error1402": "A csoport nem létezik, importálás sikertelen!",
    "error1403": "Adat hiba",
    "error1404": "Nincs elegendő jogosultság",
    "selUser": "Kérjük válasszon egy felhasználót!",
    "error1405": "Szerep lekérése sikertelen",
    "error1406": "Az importált felhasználói információ formátuma helytelen",
    "error1407": "Az e-mail már létezik, a művelet nem sikerült.",
    "error1408": "A telefon már létezik, a művelet nem sikerült.",
    "editSuccess": "Sikeresen mentve!",
    "ChangePassword": "Jelszó módosítása",
    "UserPrivacyAgreement": "Felhasználói adatvédelmi szabályzat"
  },
  "information": {
    "_2602": "Eszköz offline",
    "_2603": "Adás sikertelen",
    "_2604": "Az adás megszakadt",
    "_2605": "A tárolóhely tele van",
    "_2606": "percekkel ezelőtt",
    "_2607": "órákkal ezelőtt",
    "_2609": "sikertelen, kérjük",
    "_2609_a": "kattintson ide",
    "_2609_time": "a kezeléshez időben",
    "userType": "Rendszergazda",
    "unreadNoticeFirst": "Olvasatlan értesítés először",
    "sortByTime": "Rendezés idő szerint",
    "coxRead_1": "Olvasott",
    "coxRead_0": "Olvasatlan",
    "allCoxRead": "Mindet olvasottnak jelölni",
    "load": "Betöltés...",
    "noData": "Nincs több adat",
    "viewALLMessages": "Minden üzenet megtekintése"
  },
  "input": {
    "select": "Kérem válasszon",
    "thisField": "Ezt a mezőt ki kell tölteni.",
    "titleShooleNub60": "kevesebb mint 60 karakter",
    "titleShooleNub300": "kevesebb mint 300 karakter",
    "Offline": "Offline"
  },
  "schedule": {
    "OnlyManual": "Csak manuális",
    "runStartNow": "Feladat futtatása",
    "runStopNow": "Feladat leállítása",
    "tackExecutionStart": "A feladat fut",
    "tackExecutionStop": "A feladat végrehajtása leállítva",
    "dehumidification": "Párátlanítás",
    "airSupply": "Légellátás",
    "masterControl": "fő:",
    "powerSupply": "Áram",
    "lockScreen": "Zár",
    "RecordingControl": "Felvétel vezérlés",
    "RecordingControlSystem": "Előadás rögzítési rendszer",
    "LiquidCrystal": "Interaktív LCD kijelző",
    "projector": "Projektor",
    "othertype": "Egyéb",
    "childLock": "Gyerekzár",
    "energySaving": "Energiatakarékos",
    "signalSourceSwitching": "Bemeneti forrás",
    "other": "Egyéb jellemzők:",
    "otherFunction": "Funkció",
    "send": "Küldés",
    "ON": "BE",
    "OFF": "KI",
    "btnAddSchedule": "Visszaállítás",
    "EditSchedulelist": "Ütemező szerkesztése",
    "AddSchedulelist": "Ütemező hozzáadása",
    "RestoreSchedulelist": "Visszaállítás",
    "btn": "Mégsem",
    "btnNewList": "Új ütemező",
    "ListName": "Név",
    "Cannotquit": "Kötelező",
    "NOCannotquit": "NEM",
    "ListValidityPeriod": "Érvényességi időszak",
    "ListDescription": "Leírás",
    "currentSchedule": "Ütemezők listája",
    "historySchedule": "Történeti lista",
    "selectTime": "Idő",
    "selectTimeTable": "Idő",
    "taskType": "Feladat típusa",
    "selectBroadcasting": "Közvetítés",
    "selectDeviveControl": "Eszköz vezérlés",
    "newSchedule": "Új feladat",
    "newChecklist": "Új ellenőrzőlista",
    "titleStatus": "Állapot",
    "titleType": "Típus",
    "titleStartTime": "Kezdési idő",
    "titleEndTime": "Befejezési idő",
    "titleRepeat": "Ismétlés",
    "titleName": "Név",
    "titleAction": "Művelet",
    "tableEnabled": "Engedélyezve",
    "tablePaused": "Szüneteltetve",
    "tableEdit": "Szerkesztés",
    "tableDelete": "Törlés",
    "tableVolumeEdit": "Közvetítési hangerő",
    "tableBroadcastTitle": "Cím",
    "tableBroadcastContent": "Tartalom",
    "tableBroadcastList": "Lista",
    "tableBroadcast": "Kötelező",
    "btnRemoveCompletely": "Teljes eltávolítás",
    "btnEnabled": "Engedélyezett feladat",
    "btnPaused": "Feladat letiltása",
    "btnDelete": "Törlés",
    "repeat0": "HÉT",
    "repeat1": "KEDD",
    "repeat2": "SZERDA",
    "repeat3": "CSÜT",
    "repeat4": "PÉNTEK",
    "repeat5": "SZOMBAT",
    "repeat6": "VASÁRNAP",
    "dialogTitleAdd": "Új eszköz vezérlési feladat",
    "dialogTitleEdit": "Eszköz vezérlési feladat szerkesztése",
    "newBroadcastingSchedule": "Új közvetítési feladat",
    "editBroadcastingSchedule": "Közvetítési feladat szerkesztése",
    "chooseDevice": "Eszköz kiválasztása",
    "timeSetting": "Idő beállítás",
    "controlBroadcasting": "Közvetítési opció",
    "controlOption": "Vezérlési opció",
    "scheduleName": "Feladat neve:",
    "destination": "Cél",
    "timeTilte": "Idő",
    "repeatTitle": "Ismétlés",
    "dialogRepeat0": "HÉT",
    "dialogRepeat1": "KEDD",
    "dialogRepeat2": "SZERDA",
    "dialogRepeat3": "CSÜT",
    "dialogRepeat4": "PÉNTEK",
    "dialogRepeat5": "SZOMBAT",
    "dialogRepeat6": "VASÁRNAP",
    "dialogOnceType": "Egyszer",
    "dialogRepeatType": "Ismétlés",
    "Manual": "Manuális",
    "ManualContent": "Ezeket a feladatokat manuálisan végrehajthatja, miután befejezte a konfigurálást.",
    "mainPower": "Fő áram",
    "powerControl": "Áramvezérlés",
    "tableDisplayInputSwitch": "Kijelző bemeneti váltás",
    "tableAirConditioning": "Légkondicionáló",
    "tableProjectionScreen": "Projektor képernyő",
    "tableElectronicLock": "Elektromos zár",
    "interactiveFlatPanel": "Interaktív lapos panel",
    "displayInputSwitch": "Kijelző bemeneti váltás",
    "speakerVolume": "Hangszint",
    "MICVolume": "Mikrofon hangereje",
    "ProjectionScreen": "Projektor képernyő",
    "ElectronicLock": "Elektromos zár",
    "AirConditioning": "Légkondicionáló",
    "AirConditioningPower": "Áram",
    "AirConditioningModel": "Modell",
    "AirConditioningTEMP": "Hőmérséklet",
    "AirConditioningFanSpeed": "Ventilátor sebesség",
    "OPEN": "NYITÁS",
    "CLOSE": "ZÁRÁS",
    "UP": "FEL",
    "DOWN": "LE",
    "PowerOFF": "KI",
    "PowerON": "BE",
    "ModelAuto": "Automatikus",
    "ModelCool": "Hűtés",
    "ModelHeat": "Fűtés",
    "ModelAir": "Levegő oldali",
    "TEMPLow": "Alacsony",
    "TEMPMiddle": "Közepes",
    "TEMPHigh": "Magas",
    "btnSave": "Mentés",
    "btnNext": "KÖVETKEZŐ",
    "StartTime": "Kezdési idő",
    "StopTime": "Befejezési idő",
    "Mandatory": "Kötelező",
    "Video": "Videó és audio",
    "Notification": "Értesítés",
    "btnFile": "Válasszon egy médiát",
    "LastingTime": "Tartó idő",
    "textTitle": "Cím",
    "textContent": "Tartalom",
    "textTitleLetters": "Kevesebb mint 60 karakter",
    "textContentLetters": "Kevesebb mint 320 karakter",
    "CannotquitYES": "IGEN",
    "CannotquitNo": "Nem",
    "YES": "IGEN",
    "No": "Nem",
    "delTitleContent": "Biztosan törölni szeretné ezt az ütemezőt?",
    "delTitleListContent": "A törölt ütemező a történelem listájára kerül és visszaállítható",
    "deleListTitle": "Törölni az ütemezőt?",
    "delTitleListContent1": "A törlés miatt a hozzá kapcsolódó feladatok törlődnek, kérjük, erősítse meg.",
    "deleListTitle1": "Biztosan törölni szeretné ezt az ütemezőt?",
    "delTitle": "Törlés?",
    "btnConfirm": "Megerősítés",
    "coxAll": "MIND",
    "coxBroadcasting": "Közvetítés",
    "coxDeviveControl": "Eszköz vezérlés",
    "rdMandatory": "IGEN",
    "noRdMandatory": "NEM",
    "startDate": "Kezdési dátum",
    "endedDate": "Befejezési dátum",
    "or": "-",
    "broadcastingType": "Típus",
    "ChooseTime": "Válasszon időpontot",
    "ChooseDate": "Válasszon dátumot",
    "newScheduleList": "Új ütemező",
    "editScheduleList": "Ütemező szerkesztése",
    "listName": "Név",
    "listValidityPeriod": "Érvényességi időszak",
    "listDescription": "Leírás",
    "cancel": "Mégsem",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "addSuccess": "Hozzáadás sikeresen!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Szerkesztés sikeresen!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Törlés sikeresen!",
    "delError": "Törlés sikertelen!",
    "restoreSuccess": "Ütemező lista sikeresen visszaállítva",
    "restoreError": "Ütemező lista visszaállítása sikertelen",
    "restoreTitleContent": "Ez az időpont ütközik az ütemezett időpontokkal a listában, kérjük válasszon újra",
    "Enabled": "Engedélyezve",
    "Paused": "Szüneteltetve",
    "Title": "Cím:",
    "Content": "Tartalom:",
    "errorScheduleNameRequired": "A feladat neve kötelező",
    "errorDeviceRequired": "Kérjük, válassza ki a cél eszközt",
    "deleTitle": "Biztosan törölni szeretné ezt a feladatot?",
    "loopList": "Ismétlődő lista",
    "errorPleaseDateRange": "Kérjük, válasszon egy dátumtartományt",
    "addError_2009": "Ismétlődő ütemező név",
    "conflicts": "A feladat időpontja ütközik a következővel:",
    "Pleaseagain": "Kérjük, adja meg újra",
    "errorScheduleName": "Feladat neve",
    "errorListName": "Ütemező neve",
    "today": "Ma",
    "yesterday": "Tegnap",
    "thisWeek": "Ezen a héten",
    "lastWeek": "Múlt héten",
    "lastMonth": "Múlt hónapban",
    "thisMonth": "Ebben a hónapban",
    "times": "Időpontok",
    "TimeConflicts": "Időütközés",
    "editError_2006": "Eszköz nem található",
    "editError_2010": "Ismétlődő feladat név",
    "editError_2100": "A feladat lejárt, nem indítható el.",
    "ListTimeExpired": "Az ütemező időpontja lejárt, kérjük, válassza ki újra",
    "TimeExpired": "Idő lejárt",
    "ControlOption": "A vezérlési lehetőség hiányzik",
    "Pleaseleastone": "Kérjük, válasszon legalább egy vezérlési lehetőséget",
    "Enter": "Be",
    "TitleFilled": "A cím kötelező",
    "ContentFilled": "A tartalom kötelező",
    "PleaseMediaFile": "Kérjük, válasszon egy médiát",
    "PleaseSchedule": "Kérjük, válasszon egy feladatot",
    "delTitleScheduleContent": "A törölt feladat nem állítható vissza.",
    "deleTitleSchedule": "Biztosan törölni szeretné ezt a feladatot?",
    "deleteScheduleTitle": "Kérjük, válasszon törlendő feladatot",
    "PleaseFillColumn": "Kérjük, töltse ki az ütemező nevét",
    "PleaseDate": "Kérjük, válasszon dátumot",
    "Previous": "Előző",
    "RemoteControl": "Távvezérlés",
    "taskhasexpired": "Ez a feladat lejárt, kérjük, lépjen kapcsolatba a létrehozóval az időpont frissítéséhez.",
    "execute": "Végrehajtás",
    "broadcastingList": "Közvetítési lista",
    "volumeSuccess": "A hangerő sikeresen beállítva",
    "volumeFailed": "A hangerő beállítása sikertelen"
  },
  "live": {
    "StreamingRoom": "Streaming Szoba",
    "btnAddNewRoom": "Új Szoba Hozzáadása",
    "Steaming": "Streaming",
    "Creater": "host:",
    "Address": "RTMP Cím:",
    "StreamingURL": "Élő Streaming URL:",
    "DestinationNMP": "Válassza ki a célt NMP:",
    "stop": "ÁLLJ",
    "stat": "KÉSZ",
    "btnCope": "Kattintson a másoláshoz",
    "QRcode": "QR Kód",
    "Refresh": "Frissítés",
    "AddNewRoomTitle": "Új Streaming Szoba Hozzáadása",
    "editNewRoomTitle": "Streaming Szoba Szerkesztése",
    "roomName": "Szoba név:",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "delTitleContent": "Biztosan törölni szeretné ezt az ütemezést?",
    "delTitle": "Törlés?",
    "delCancelButton": "Mégse",
    "delConfirmButton": "Megerősítés",
    "addSuccess": "Hozzáadás sikeres!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Szerkesztés sikeres!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Törlés sikeres!",
    "delError": "Törlés sikertelen!",
    "Stopstreaming": "Streaming leállítása",
    "Startstreaming": "Streaming indítása",
    "error2504": "Nem sikerült megszerezni a média szerver élő streaming címét",
    "error2505": "Ismétlődő streaming szoba név",
    "error2506": "Az eszközt másik streaming jel használja",
    "error1900": "A hozzáfért paraméter üres",
    "error2503": "Nem sikerült megszerezni a média szerver információit",
    "error2507": "Ismétlődő élő streaming cím",
    "copySuccess": "A tartalom a vágólapra lett másolva.",
    "copyError": "A böngésző nem támogatja az automatikus másolást",
    "flashControl": "A Flash nincs telepítve vagy engedélyezve. Kérem próbálja újra a telepítés vagy engedélyezés után.",
    "liveStreaming": "Nem található élő streaming forrás.",
    "btnflash": "Telepítés/Engedélyezés",
    "serverAddress": "Szerver cím",
    "addressKey": "Kulcs:",
    "watchingAddress": "Néző cím",
    "audioOnly": "Csak Hang",
    "enterTheKey": "A kulcsot ki kell tölteni."
  },
  "guidepages": {
    "next": "Következő – eszköz vezérlés",
    "next1": "Következő – próbálja vezérelni",
    "next2": "Következő – közvetítés",
    "next3": "Következő – közvetítés indítása",
    "next4": "Következő – közvetítés leállítása",
    "next5": "Következő – szöveges közvetítés",
    "next6": "Következő – feladat beállítása",
    "next7": "Következő – új feladat hozzáadása",
    "next8": "Következő – történelem lista",
    "next9": "Következő – felhő tárolás",
    "next10": "Következő – élő közvetítés",
    "next11": "Következő – élő közvetítés beállítása",
    "exit": "Kilépés",
    "guideContent": "Útmutató tartalom",
    "btnHomepage": "Főoldal",
    "btnDevices": "Eszközök",
    "btnBroadcast": "Közvetítés",
    "btnSchedule": "Ütemezés",
    "btnResources": "Erőforrások",
    "btnStreaming": "Élő",
    "btnPrevious": "Előző"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    	}
}



// WEBPACK FOOTER //
// ./src/lang/hu.js